import { defineStore } from 'pinia';
import { useUserStore } from '@/stores/UserStore'
import mainAPI from "@/api/mainAPI";
import MyPlugin from "@/plugins/plugin";
import languages from '@/configs/language';
import { useGeneralStore } from '@/stores/GeneralStore'


export const useCustomerStore = defineStore("CustomerStore", {
    state: () => ({
        selectedCustomerData: {},
        selectedCustomerLocationData: [],
        selectedLocationDetail: {},
        customerData:  [],
        prefixData: [],
        customerPicData: [],
    }),
    getters: {
    },
    actions: {
        async getCustomer(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETCUSTOMER",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);

            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success", data: res.data.data }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.`, data: this.customerData }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async storeCustomer(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "STORECUSTOMER",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success", userId: res.data.data[0].id }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCompanyPrefix(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "FILTERCOMPANYPREFIX",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }
            // let res = await mainAPI.listMenu(args.username, args.versioncode);
            let res = await mainAPI.requestHandler(header, body);

            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                this.prefixData = res.data.data
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCustomerById(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETCUSTOMER",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);

            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                this.selectedCustomerData = res.data.data[0]
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async updateCustomer(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "UPDATECUSTOMER",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async destroyCustomer(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "DESTROYCUSTOMER",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCustomerLocation(params, isDetail) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETLOCATION",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }


            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                
                if (isDetail) {
                    this.selectedLocationDetail = res.data.data[0]
                    return { status: "ok", message: "Success" };
                } else {
                    this.selectedCustomerLocationData = res.data.data;
                    return { status: "ok", message: "Success" };
                }
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCustomerLocationGmaps(params, isDetail) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETLOCATIONMAP",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }


            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                
                if (isDetail) {
                    this.selectedLocationDetail = res.data.data[0]
                    return { status: "ok", message: "Success" };
                } else {
                    this.selectedCustomerLocationData = res.data.data;
                    return { status: "ok", message: "Success" };
                }
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async storeLocation(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "STORELOCATION",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success" };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async storeLocationGmaps(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "STORELOCATIONMAP",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success" };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async updateLocation(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "UPDATELOCATION",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success" };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async updateLocationGmaps(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "UPDATELOCATIONMAP",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success" };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async destroyLocation(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "DESTROYLOCATION",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success" };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCountries(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "GETCOUNTRY",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success", data: res.data.data };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                return resp;
            }
        },

        async getProvinces(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");
            
            // API Request
            let apiData = {
                "apirequest": "GETPROVINCE",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success", data: res.data.data };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                return resp;
            }
        },

        async getCities(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "GETCITY",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success", data: res.data.data };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                return resp;
            }
        },

        async getDistricts(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            const timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            // API Request
            let apiData = {
                "apirequest": "GETDISTRICT",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }
            let body = {
                apidata: apiData,
                params: params
            }
            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);
            let header = {
                "X-Signature": signature
            }

            // API Response
            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                return { status: "ok", message: "Success", data: res.data.data };
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                return resp;
            }
        },

        async storeCustomerPic(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "STORECUSTOMERPIC",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async updateCustomerPic(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "UPDATECUSTOMERPIC",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async destroyCustomerPic(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "DESTROYCUSTOMERPIC",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getCustomerPic(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETCUSTOMERPIC",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);

            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success", data: res.data.data }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.`, data: this.customerPicData }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async storeMultipleLocation(params) {
            const userStore = useUserStore();
            let generalStore = useGeneralStore();

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "STOREMULTIPLELOCATION",
                "user_id": userStore.user_id,
                "user_key": userStore.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, userStore.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);

            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success", data: res.data.data }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.`, data: this.customerPicData }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },
    }
})